import { useEffect, useState } from 'react';
const DEFAULT_OPTIONS = {
  attributes: true,
  childList: true,
  subtree: true
};
function useDocumentMutation(onDocumentMutation, options = DEFAULT_OPTIONS) {
  const [observer, setObserver] = useState(null);
  useEffect(() => {
    setObserver(new MutationObserver(onDocumentMutation));
  }, [onDocumentMutation]);
  useEffect(() => {
    observer == null ? void 0 : observer.observe(document, options);
    return () => {
      observer == null ? void 0 : observer.disconnect();
    };
  }, [observer, options]);
}
export default useDocumentMutation;